module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('el-row', {
    staticClass: "panel"
  }, [_c('el-col', {
    staticClass: "panel-top",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticStyle: {
      "font-size": "26px"
    },
    attrs: {
      "span": 14
    }
  }, [_c('img', {
    staticClass: "logo",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": require("../assets/img/aicon02.png")
    },
    on: {
      "click": _vm.handleHyy
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "right_action",
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "rightbar",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('strong', {
    staticClass: "imgUrlstrong"
  }, [_vm._v(_vm._s(_vm.imgUrl))]), _vm._v(" "), _c('span', {
    staticClass: "name",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.show = !_vm.show
      }
    }
  }, [_c('span', {
    staticClass: "strongName"
  }, [_vm._v(_vm._s(_vm.username))])]), _vm._v(" "), _c('img', {
    staticClass: "usermessage",
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "src": require("../assets/img/aicon42.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.show = !_vm.show
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "xiugai"
  }, [_c('span', {
    staticClass: "mimaxiugai xgmmClass",
    on: {
      "click": function($event) {
        return _vm.handleModify(1)
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('span', {
    staticClass: "mimaxiugai gzgzhClass",
    on: {
      "click": function($event) {
        return _vm.handleModify(2)
      }
    }
  }, [_vm._v("修改手机")])])])]), _vm._v(" "), _c('div', {
    staticClass: "closeImg"
  }, [_c('img', {
    staticClass: "login_out",
    attrs: {
      "src": require("../assets/img/aicon12_03.png")
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  })])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "panel-center",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    attrs: {
      "id": "leftMenu"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "theme": "dark",
      "unique-opened": "",
      "router": ""
    }
  }, [_vm._l((_vm.menu), function(item, index) {
    return [(item.childs.length > 0) ? _c('el-submenu', {
      key: index + '',
      attrs: {
        "index": index + '',
        "default-active": item.menuurl
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('img', {
      staticStyle: {
        "width": "18px"
      },
      attrs: {
        "src": item.icon
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "have first_title"
    }, [_vm._v(_vm._s(item.menuname))])]), _vm._v(" "), _vm._l((item.childs), function(item) {
      return [_vm._l((item.childs), function(child) {
        return _c('el-menu-item', {
          key: child.menuid,
          attrs: {
            "index": child.menuurl,
            "default-active": item.menuurl,
            "data-parentId": item.menuid,
            "data-id": child.menuid
          },
          on: {
            "click": _vm.menuTab
          }
        }, [_vm._v(_vm._s(child.menuname))])
      }), _vm._v(" "), _c('el-menu-item', {
        key: item.menuurl,
        attrs: {
          "index": item.menuurl,
          "default-active": item.menuurl,
          "data-id": item.menuid,
          "data-parentId": item.menuid
        },
        on: {
          "click": _vm.menuTab
        }
      }, [_c('i', {
        staticClass: "first_title"
      }, [_vm._v(_vm._s(item.menuname))])])]
    })], 2) : _c('el-menu-item', {
      key: item.menuurl,
      staticClass: "yijimenu",
      attrs: {
        "data-id": item.menuid,
        "index": item.menuurl,
        "data-parentId": item.menuid
      },
      on: {
        "click": _vm.menuTab
      }
    }, [_c('img', {
      staticStyle: {
        "width": "18px"
      },
      attrs: {
        "src": item.icon
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "first_title"
    }, [_vm._v(_vm._s(item.menuname))])])]
  })], 2)], 1), _vm._v(" "), _c('section', {
    ref: "main_container",
    staticClass: "panel-c-c"
  }, [_c('div', {
    staticClass: "panel_nav"
  }, [_c('el-col', {
    staticClass: "nav",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, _vm._l((this.$route.meta), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: index,
      attrs: {
        "to": item.url
      }
    }, [(item.url) ? _c('router-link', {
      attrs: {
        "to": item.url
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('a', [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "view_container clearfix",
    staticStyle: {
      "margin-right": "0px"
    }
  }, [_c('el-col', {
    staticClass: "clearfix",
    staticStyle: {
      "background-color": "#fff",
      "box-sizing": "border-box"
    },
    attrs: {
      "span": 24
    }
  }, [_c('keep-alive', {
    attrs: {
      "include": "answer,refund,brand"
    }
  }, [_c('router-view', {
    attrs: {
      "menuAction": _vm.menuAction
    }
  })], 1)], 1)], 1)], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b6469b9c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 1744
// module chunks = 3